import {LitElement, html, css} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {navigator, router} from 'lit-element-router';
import {msg, str} from '@lit/localize';
import {connect} from 'pwa-helpers';
import {when} from 'lit/directives/when.js';

import style from '../../../../scss/accountListItem.scss';
import listStyle from '../../../../scss/list.scss';
import store from '../../store';
import {openDialog} from '../../slices/statusSlice';
import {routeUrl} from '../../util/routeUrl';
import getRoutes from '../../routes';
import {selectLanguage, selectProfileDefaultLanguage} from '../../selectors';

@customElement('arc-account-list-item')
export class AccountListItem extends connect(store)(router(navigator(LitElement))) {
	static styles = [listStyle, style];

	static properties = {
		account: {type: Object},
		currentLanguage: {type: String},
		customClass: {type: String},
		isDropdownOpen: {type: Boolean},
	};

	constructor() {
		super();
		this.isDropdownOpen = false;
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
		this.lang = selectLanguage(state);
		this.currentLanguage = selectProfileDefaultLanguage(state);
	}
	static get routes() {
		return getRoutes();
	}
	router(route, params, query, data) {
		this.route = route;
		this.params = params;
	}

	connectedCallback() {
		super.connectedCallback();
	}

	handleDeleteAccount() {
		const title = this.account.name;
		store.dispatch(
			openDialog({
				title: msg('Remove Account'),
				warningMessage: msg(
					str`Removing Account "${title}" will immediately remove it from your list of Accounts.`
				),
				labelCancel: msg('Cancel'),
				labelConfirm: msg('Remove Account'),
			})
		);
		this._handleConfirm = async () => {
			// await store.dispatch(deleteAccount({id: this.account.id}));
			this.dispatchEvent(
				new CustomEvent('account-deleted', {
					bubbles: true,
					composed: true,
					detail: {artworkId: this.account.id},
				})
			);
			window.removeEventListener('confirm', this._handleConfirm);
		};
		window.addEventListener('confirm', this._handleConfirm);
	}
	handleEditAccount(accountId) {
		this.navigate(routeUrl('admin-account', {...this.params, ...{accountId: this.account.id, mode: 'edit'}}));
	}
	render() {
		return html`
			<div class="listItem" @click="${this.handleEditAccount}">
				<div>${this.account.role}</div>
				<div class="title">
						${this.account.name}
				</div>
				<div>
						${this.account.email}
				</div>
				<div>
					${this.account.isEnabled ? msg('Yes') : msg('No')}
				</div>
				<div>
					${this.account.isTest ? msg('Yes') : msg('No')}
				</div>
				<div>
					${this.account.hasLoggedInOnce ? msg('Yes') : msg('No')}
				</div>
				<div>
					${this.account.invitedByName}
				</div>
				<div>
					${when(this.account.isOrgMember, () => html`
						${this.account.orgInfo?.organization}<br>
						${this.account.orgInfo?.membershipNumber}
					`)}
				</div>
			</div>
			<div class="listButtons">
				<arc-dropdown-menu>
					<arc-button
						type="listMenu"
						title="${msg('Edit')}"
						@click=${() => this.handleEditAccount()}>
						${msg('Edit')}
					</arc-button>
				</arc-dropdown-menu>
			</div>
		`;
	}
}
